import { render, staticRenderFns } from "./charges-modal.vue?vue&type=template&id=0adc2dde"
import script from "./charges-modal.vue?vue&type=script&lang=js"
export * from "./charges-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports